import { pairEqual, pairLessOrEqual, tripleEqual, tripletLessOrEqual } from './comparators';
export function yearRangeMapper(startYear, endYear) {
    return rangeMapper(startYear, endYear, (a, b) => a === b, (a, b) => a <= b);
}
export function monthRangeMapper(start, end) {
    return rangeMapper(start, end, pairEqual, pairLessOrEqual);
}
export function quarterRangeMapper(start, end) {
    return rangeMapper(start, end, pairEqual, pairLessOrEqual);
}
export function dateRangeMapper(start, end) {
    return rangeMapper(start, end, tripleEqual, tripletLessOrEqual);
}
export function weekRangeMapper(start, end) {
    return rangeMapper(start, end, pairEqual, pairLessOrEqual);
}
function rangeMapper(start, end, equal, lessOrEqual) {
    if (start !== undefined && end !== undefined) {
        return key => {
            if (equal(key, start) || equal(key, end)) {
                return 'selected';
            }
            else {
                return lessOrEqual(start, key) && lessOrEqual(key, end) ? 'range' : 'none';
            }
        };
    }
    else if (start !== undefined || end !== undefined) {
        return key => (start !== undefined && equal(key, start)) || (end !== undefined && equal(key, end))
            ? 'selected'
            : 'none';
    }
    else {
        return () => 'none';
    }
}
export function yearHoverStateMapper(startYear, hoverYear) {
    return rangeHoverMapper(startYear, hoverYear, (a, b) => a === b, (a, b) => a <= b);
}
export function monthHoverStateMapper(start, hover) {
    return rangeHoverMapper(start, hover, pairEqual, pairLessOrEqual);
}
export function quarterHoverStateMapper(start, hover) {
    return rangeHoverMapper(start, hover, pairEqual, pairLessOrEqual);
}
export function dateHoverStateMapper(start, hover) {
    return rangeHoverMapper(start, hover, tripleEqual, tripletLessOrEqual);
}
export function weekHoverStateMapper(start, hover) {
    return rangeHoverMapper(start, hover, pairEqual, pairLessOrEqual);
}
function rangeHoverMapper(start, hover, equal, lessOrEqual) {
    return key => {
        if (equal(key, start)) {
            return 'selected';
        }
        else if ((lessOrEqual(start, key) && lessOrEqual(key, hover)) ||
            (lessOrEqual(hover, key) && lessOrEqual(key, start))) {
            return 'range-hover';
        }
        else {
            return 'none';
        }
    };
}
